/**
 * Version 1.0.0
 */
const axios = require("axios");
const Qs = require("qs");

/**
 * Post the action and data to WordPress.
 * The data arrives in WordPress as an associative array
 *
 * @param {string} action
 * @param {Object} data
 */
export async function ajaxCall(action, data) {
  let res = axios
    .post("/wp-admin/admin-ajax.php", Qs.stringify({ action, ...data }))
    .then((res) => {
      return res;
    })
    .catch(function (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.error(error.response.data);
        console.error(error.response.status);
        console.error(error.response.headers);
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        console.error(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.error("Error", error.message);
      }
      console.error(error.config);
    });

  let result = await res;

  return result;
}
